import { message } from 'doraemon';
import {
  reqDetail,
  reqList,
  reqDelete, 
  addOrEdit,
  getUserCategoryTree,
  getRoleTreeByCategory,
  updateStatus,
  patchDelete,
  getOrgPostTemplate,
  changeTemplate,
  fetchRoleList,
  getRoleDetail,
  fetchPagingPositions,
  getPosDetail,
  getPrivilegeTree,
  getPrivilegeDetail,
  getHasRoleCategory,
  checkRoleGroupRoles,
  checkRoleTree4RoleGroup,
} from '../services';


/**
 * 请求错误信息统一处理
 * @param message
 */
const responseErrorHandle = (msg) => {
  message.info(msg);
};

function makeTreeData (data) {
  if (Array.isArray(data)) {
    return data?.map((item) => {
      return {
        title: item.name,
        value: item.code,
        key: item.code,
        children: makeTreeData(item.chiidren),
      };
    });
  }
  return null;
}
function makeRoleTreeData (data) {
  if (Array.isArray(data)) {
    return data?.map((item) => {
      return {
        title: item.title,
        value: item.code,
        key: item.key,
        type: item.type,
        parentCode: item.parentCode ? item.parentCode?.split('/') : [],
        children: makeRoleTreeData(item.children),
      };
    });
  }
  return [];
}

const convertTree = (data) => {
  return (
    Array.isArray(data) &&
    data.reduce((pre, cur) => {
      const { children = [] } = cur;
      return pre.concat([cur], convertTree(children || []));
    }, [])
  );
};
export default {
  namespace: 'privilege',
  state: {
    tableQueryParams: {
      pageNo: 1,
      pageSize: 10,
    },
    list: {},
    detail: {},
    timeLine: [],
    userCategory: [],
    roleTreeData: [],
    roleCategory: [],
    convertRoleTreeData: [],
  },
  effects: {
    * fetchDetail ({ payload }, { call, put }) {
      const res = yield call(reqDetail, payload);
      if (res.success) {
        yield put({
          type: 'update',
          payload: {
            detail: res.result,
          },
        });
      } else {
        responseErrorHandle(res.message);
      }
      return res;
    },
    * fetchList ({ payload }, { call, put }) {
      const res = yield call(reqList, payload);
      if (res.success) {
        yield put({
          type: 'update',
          payload: {
            list: res.result,
          },
        });
      } else {
        responseErrorHandle(res.message);
      }
      return res;
    },
    * delete ({ payload }, { call }) {
      return yield call(reqDelete, payload);
    },
    * patchDelete ({ payload }, { call }) {
      return yield call(patchDelete, payload);
    },
    * addOrEdit ({ payload }, { call }) {
      return yield call(addOrEdit, payload);
    },
    * getUserCategoryTree ({ payload }, { call, put }) {
      const res = yield call(getUserCategoryTree, payload);
      yield put({
        type: 'update',
        payload: {
          userCategory: makeTreeData(res.result),
        },
      });
      return res;
    },
    * getRoleTreeByCategory ({ payload }, { call, put }) {
      const res = yield call(getRoleTreeByCategory, payload);
      yield put({
        type: 'update',
        payload: {
          roleTreeData: makeRoleTreeData(res),
          convertRoleTreeData: convertTree(makeRoleTreeData(res)),
        },
      });
      return res;
    },
    * getHasRoleCategory ({ payload }, { call, put }) {
      const res = yield call(getHasRoleCategory, payload);
      yield put({
        type: 'update',
        payload: {
          roleCategory: res.result,
        },
      });
      return res;
    },
    * updateStatus ({ payload }, { call }) {
      return yield call(updateStatus, payload);
    },
    * getOrgPostTemplate ({ payload }, { call }) {
      return yield call(getOrgPostTemplate, payload);
    },
    *  changeTemplate ({ payload }, { call }) {
      return yield call(changeTemplate, payload);
    },
    * fetchRoleList ({ payload }, { call }) {
      return yield call(fetchRoleList, payload);
    },
    * getRoleDetail ({ payload }, { call }) {
      return yield call(getRoleDetail, payload);
    },
    * fetchPagingPositions ({ payload }, { call }) {
      return yield call(fetchPagingPositions, payload);
    },
    * getPosDetail ({ payload }, { call }) {
      return yield call(getPosDetail, payload);
    },
    * getPrivilegeTree ({ payload }, { call }) {
      return yield call(getPrivilegeTree, payload);
    },
    * getPrivilegeDetail ({ payload }, { call }) {
      return yield call(getPrivilegeDetail, payload);
    },
    * checkRoleGroupRoles ({ payload }, { call }) {
      const { success, result } = yield call(checkRoleGroupRoles, payload) || {};
      if (!success) {
        return responseErrorHandle('服务器开小差了,请稍后再试');
      }
      return result;
    },
    * checkRoleTree4RoleGroup ({ payload }, { call }) {
      const { success, result } = yield call(checkRoleTree4RoleGroup, payload) || {};
      if (!success) {
        return responseErrorHandle('服务器开小差了,请稍后再试');
      }
      return result;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
